import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import {Link, useLocation, useNavigate, useParams} from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import {Logo} from "../../../../icons/icons";
import CustomInput from "../../../../components/UI/customInput/customInput";
import CustomButton from "../../../../components/UI/customButton/customButton";
import AppSection from "../../../../components/appSection/app-section";
import {Post} from "../../../../apis/api";
import {toggleAuth} from "../../../../store/user/user.reducer";
import {setPermissions} from "../../../../store/permissions/permissions.reducer";

const Index = () => {
  const [type, setType] = useState(1);
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const param = useParams()
  console.log(param)
  const handleForm = ({ name, value }) => {
    setForm((prevState) => ({ ...prevState, [name]: value }));
  };

  useEffect(() => {
    setForm({});
    if(param.id) {
      setForm({referral:param.id})
    }
  }, [type]);

  const handleSubmit = () => {
    setLoading(true);
    Post("crew/sign-up", { ...form })
      .then((res) => {
        dispatch(toggleAuth(res?.details));
        dispatch(setPermissions(res?.details?.permissions));
        navigate(`/crew/auth/Otp?email=${form.email}`);
      })
      .catch((error) => {
        toast.error(error.data.message || error.data.msg)
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className={"flex flex-col justify-center items-center mt-10 mb-10 md:mb-0 md:mt-20"}>
        <div key={"login" + type} className={"rounded-lg bg-white p-5 flex items-center justify-center flex-col min-w-[350px] gap-5 shadow-2xl"}>
          <Logo />
          <CustomInput
            placeHolder={"First Name"}
            label={"First Name"}
            name={"name"}
            onchange={handleForm}
          />
          <CustomInput
            placeHolder={"Last Name"}
            label={"Last Name"}
            name={"last_name"}
            onchange={handleForm}
          />
          <CustomInput
            placeHolder={"Email"}
            label={"Email"}
            name={"email"}
            onchange={handleForm}
          />
          <CustomInput
            disable={param.id}
            defaultValue={param.id}
            placeHolder={"referral code"}
            label={"referral code"}
            name={"referral"}
            onchange={handleForm}
          />
          <CustomInput
            placeHolder={"password"}
            label={"password"}
            name={"password"}
            onchange={handleForm}
          />
          <CustomButton loading={loading} onClick={handleSubmit} title={"Sign Up"} />

          <div className={"w-full gap-4 flex justify-center cursor-pointer"}>
          <div onClick={() => setType(2)}>
            <Link  className={"text-gray-500 text-xs text-end w-full"}>
              {"Have an account ? "}
            </Link>
          </div>
          <div onClick={() => setType(2)}>
            <Link to={"/crew/auth/login"} className={"text-main text-sm text-end w-full"}>
              {"Login"}
            </Link>
          </div>
        </div>

        </div>

      <AppSection />
    </div>
  );
};

export default Index;
